/*
 * ATC handler for s2c-product-card. Uses data-s2c-qadd so it doesn't
 * collide with sections that have their own data-s2x-qadd handler
 * (e.g., s2c-home-bestsellers, s2c-collection-grid).
 */
(function () {
  if (window.__s2cProductCardBound) return;
  window.__s2cProductCardBound = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-s2c-qadd]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;
    var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!vid) return;
    btn.disabled = true;
    var originalLabel = btn.textContent;
    btn.textContent = 'Tilføjer…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () {
        btn.classList.add('is-done');
        btn.textContent = '✓ Lagt i kurv';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () {
          btn.disabled = false;
          btn.classList.remove('is-done');
          btn.textContent = originalLabel;
        }, 1600);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = originalLabel;
      });
  });
})();
